import React from 'react';
import { Link } from 'react-router-dom';
import { Linkedin, Twitter, Facebook, ArrowRight } from 'lucide-react';

const team = [
  { name: 'Vimal George', role: 'Founder / CEO', bio: 'I am an ambitious workaholic, but apart from that, pretty simple person.', initials: 'VG', color: '#C9A84C' },
];

export default function WhoWeAre() {
  return (
    <div className="page-enter">
      <style>{`
        .page-hero { background: var(--charcoal-dark); padding: 72px 0; position: relative; overflow: hidden; }
        .page-hero-img { position:absolute; inset:0; background-image:url('https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=1600&h=500&fit=crop&q=80'); background-size:cover; background-position:center; filter:saturate(1.05) brightness(0.9); }
        .page-hero-overlay { position:absolute; inset:0; background: linear-gradient(90deg, rgba(26,26,24,0.94) 0%, rgba(26,26,24,0.8) 35%, rgba(26,26,24,0.45) 68%, rgba(26,26,24,0.2) 100%); }
        .page-hero::before { content:''; position:absolute; right:0; top:0; bottom:0; width:40%; background: radial-gradient(circle at 80% 50%, rgba(201,168,76,0.14),transparent 70%); pointer-events:none; z-index:1; }
        .ph-breadcrumb { font-size:12px; color:rgba(255,255,255,0.4); margin-bottom:12px; }
        .ph-breadcrumb a { color:var(--gold); }
        .ph-title { font-family:var(--font-display); font-size:clamp(32px,4vw,52px); font-weight:700; color:white; line-height:1.15; margin-bottom:12px; }
        .ph-title em { font-style:italic; color:var(--gold); }
        .ph-sub { font-size:16px; font-weight:300; color:rgba(255,255,255,0.6); max-width:580px; line-height:1.75; }
        .who-intro { padding:88px 0; background:var(--white); }
        .who-intro-grid { display:grid; grid-template-columns:1fr 1fr; gap:80px; align-items:start; }
        .wio-quote { border-left:4px solid var(--gold); border-radius:0 var(--radius-sm) var(--radius-sm) 0; padding:24px 28px; background:var(--gold-bg); font-family:var(--font-display); font-size:18px; font-style:italic; color:var(--charcoal-dark); line-height:1.65; margin-bottom:24px; }
        .wio-text { font-size:15px; line-height:1.85; color:var(--text-body); margin-bottom:16px; }
        .who-right-box { background:var(--charcoal-dark); padding:44px 40px; margin-bottom:20px; border-radius:var(--radius); }
        .wrb-title { font-family:var(--font-display); font-size:22px; font-weight:700; color:white; margin-bottom:14px; }
        .wrb-text { font-size:14px; line-height:1.8; color:rgba(255,255,255,0.6); margin-bottom:24px; }
        .wrb-tagline { font-family:var(--font-display); font-size:18px; font-style:italic; color:var(--gold); border-top:1px solid rgba(255,255,255,0.1); padding-top:18px; }
        .who-vals { display:grid; grid-template-columns:1fr 1fr; gap:14px; }
        .who-val { padding:18px; background:var(--off-white); border:1px solid var(--border); border-radius:var(--radius-sm); text-align:center; transition:all 0.22s; }
        .who-val:hover { border-color:var(--gold); background:var(--gold-bg); }
        .wv-icon { font-size:26px; margin-bottom:8px; }
        .wv-label { font-size:12px; font-weight:700; color:var(--text-dark); }
        .team-full { padding:88px 0; background:var(--off-white); }
        .team-full-grid { display:flex; flex-wrap:wrap; justify-content:center; gap:24px; margin-top:52px; }
        .team-full-grid .tfc { width:300px; }
        .tfc { background:var(--white); border:1px solid var(--border); border-radius:var(--radius); overflow:hidden; transition:all 0.28s ease; }
        .tfc:hover { box-shadow:var(--shadow-lg); transform:translateY(-5px); border-color:var(--gold); }
        .tfc-avatar { height:200px; display:flex; align-items:center; justify-content:center; position:relative; overflow:hidden; }
        .tfc-initials { font-family:var(--font-display); font-size:56px; font-weight:700; color:rgba(255,255,255,0.2); position:relative; z-index:1; }
        .tfc-bar { position:absolute; bottom:0; left:0; right:0; height:4px; background:var(--gold); }
        .tfc-info { padding:24px 20px; }
        .tfc-role { font-size:11px; font-weight:600; letter-spacing:2px; text-transform:uppercase; color:var(--gold); margin-bottom:4px; }
        .tfc-name { font-family:var(--font-display); font-size:20px; font-weight:700; color:var(--text-dark); margin-bottom:8px; }
        .tfc-bio { font-size:13px; line-height:1.65; color:var(--text-light); margin-bottom:14px; }
        .tfc-links { display:flex; gap:8px; }
        .tfc-link { width:30px; height:30px; border-radius:50%; border:1px solid var(--border); display:flex; align-items:center; justify-content:center; color:var(--grey-400); transition:all 0.2s; cursor:pointer; }
        .tfc-link:hover { background:var(--charcoal-dark); color:white; border-color:var(--charcoal-dark); }
        .tfc-join { height:200px; background:var(--gold-bg); border:2px dashed rgba(201,168,76,0.35); display:flex; flex-direction:column; align-items:center; justify-content:center; gap:8px; padding:24px; text-align:center; }
        .tfj-title { font-family:var(--font-display); font-size:18px; font-weight:700; color:var(--text-dark); }
        .tfj-text { font-size:13px; color:var(--text-light); }
        @media (max-width:900px) { .who-intro-grid{grid-template-columns:1fr;gap:40px;} .who-vals{grid-template-columns:1fr 1fr;} }
        @media (max-width:560px) { .team-full-grid .tfc{width:100%;max-width:340px;} }
      `}</style>

      <div className="page-hero">
        <div className="page-hero-img" />
        <div className="page-hero-overlay" />
        <div className="container" style={{position:'relative',zIndex:2}}>
          <div className="ph-breadcrumb"><Link to="/">Home</Link> / Who We Are</div>
          <h1 className="ph-title">Who We <em>Are</em></h1>
          <p className="ph-sub">At Trinity Accounting, you are not just a tax return. We realise that your business is more than just numbers — we value that.</p>
        </div>
      </div>

      <section className="who-intro">
        <div className="container">
          <div className="who-intro-grid">
            <div>
              <span className="section-eyebrow">Our Story</span>
              <h2 className="section-title">Tools Should Adapt to<br /><em>the User</em></h2>
              <div className="wio-quote">"At Trinity Accounting, you are not just a tax return."</div>
              <p className="wio-text">We realise that your business to you is more than just numbers; we value that. With a combined experience of over eight years in Accounting and Taxation, we can ensure you the best possible outcome for all your obligations — whether it is a Tax return, Business structuring, Bookkeeping, or even in the day-to-day running of the business.</p>
              <p className="wio-text">Together, we strive to excel every day by doing better than the last day until we reach our goal — financial freedom. Let's be wings of your Dreams.</p>
              <div className="who-vals">
                {[['🎯','Goal Oriented'],['💡','Innovative'],['🔒','Trustworthy'],['📈','Growth Focused']].map(([icon, label]) => (
                  <div key={label} className="who-val">
                    <div className="wv-icon">{icon}</div>
                    <div className="wv-label">{label}</div>
                  </div>
                ))}
              </div>
            </div>
            <div>
              <div className="who-right-box">
                <div className="wrb-title">Our Mission</div>
                <p className="wrb-text">Trinity Accounting Consultants is an independent firm providing value-added tax and advisory solutions. We are committed to helping our clients achieve financial freedom through expert guidance and personalised service.</p>
                <p className="wrb-text">Based in Toowoomba, Australia, we serve clients across the region with professional, qualified accounting and tax services tailored to each individual's unique needs.</p>
                <div className="wrb-tagline">"Let's be wings of your Dreams."</div>
              </div>
              <div style={{padding:'24px',border:'1px solid var(--border)',borderRadius:'var(--radius-sm)',background:'var(--white)',display:'flex',gap:'16px',alignItems:'center'}}>
                <div style={{fontFamily:'var(--font-display)',fontSize:'42px',fontWeight:700,color:'var(--gold)',minWidth:'64px',lineHeight:1}}>8+</div>
                <div>
                  <div style={{fontSize:'14px',fontWeight:700,color:'var(--text-dark)'}}>Years of Combined Experience</div>
                  <div style={{fontSize:'13px',color:'var(--text-light)'}}>in Accounting and Taxation</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="team-full">
        <div className="container">
          <div style={{textAlign:'center'}}>
            <span className="section-eyebrow">Our Team</span>
            <h2 className="section-title">Creative Minds by <em>People Like You</em></h2>
          </div>
          <div className="team-full-grid">
            {team.map(({ name, role, bio, initials, color }) => (
              <div key={name} className="tfc">
                <div className="tfc-avatar" style={{background:`linear-gradient(135deg, ${color}, ${color}88)`}}>
                  <div className="tfc-initials">{initials}</div>
                  <div className="tfc-bar" />
                </div>
                <div className="tfc-info">
                  <div className="tfc-role">{role}</div>
                  <div className="tfc-name">{name}</div>
                  <div className="tfc-bio">{bio}</div>
                  <div className="tfc-links">
                    <div className="tfc-link"><Linkedin size={13} /></div>
                    <div className="tfc-link"><Twitter size={13} /></div>
                    <div className="tfc-link"><Facebook size={13} /></div>
                  </div>
                </div>
              </div>
            ))}
            <div className="tfc">
              <div className="tfc-join">
                <div style={{fontSize:'40px'}}>🚀</div>
                <div className="tfj-title">Want a New Challenge?</div>
                <div className="tfj-text">Browse our job opportunities and become a member of the family!</div>
              </div>
              <div className="tfc-info">
                <div className="tfc-role">Careers</div>
                <div className="tfc-name">Join Our Team</div>
                <Link to="/contact" className="btn-dark" style={{fontSize:'12px',padding:'10px 20px',marginTop:'4px',display:'inline-flex',alignItems:'center',gap:'6px'}}>
                  Apply Now <ArrowRight size={12} />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
